import React, { useState } from 'react';
import '../css/animate.css';
import '../css/barvy.css';
import '../css/style.css';
import {motion} from "framer-motion";
import { useEffect } from 'react';
import {builder} from '../utils/builderWithLocale';
import { getLocalizedText } from '../utils/textLocalization';

function App() {
  const [content, setContent] = useState({"data": []});
  const [parts, setParts] = useState([]);
  
  useEffect(() => {
    document.title = getLocalizedText('general.o-ridley_page_title');
    builder
      .get("onas", {
        cache: true,
        cacheTime: 1800
      })
      .then((data) => {
        setContent(data);
        setParts(data.data.list);
      })
      .catch((error) => console.error("Error fetching content:", error));
  }, []);

  const isEven = (number) => {
    if (number % 2 === 0) {
      return true;
    } else {
      return false;
    }
  }

  return (
    <>
    <motion.div  key="loading"initial={{ opacity: 0 }}animate={{ opacity: 1 }}exit={{ opacity: 0 }}transition={{ duration: 0.3 }}>

    <div id="o-ridley" className="scrollto clearfix o-ridley">


        {/* SECTION 1*/}
        <div className="row no-padding-bottom clearfix">
            <div className="col-3">
            </div>
            <div>
                <div className="section-heading">
                    <h3 className={`col-3 barlow-semibold ${!content.data.nazev && 'loading-text'}`}>{content.data.nazev || "loading..."}</h3>
                    <h2 className={`col-3 section-title onas-title white-title ${!content.data.hlavniNazev && 'loading-text'}`} id="about-nadpis">{content.data.hlavniNazev || "loading..."}</h2>
                    <div className="onas-data">

                    {parts.map((element, index) => (
                      <React.Fragment key={index}>
                      {/* onas-image-right / onas-image-left */}
                      <div className={isEven(index) ? "col-3 onas-image-right" : "col-3 onas-image-left"}>
                        <img src={element.obrazek} alt="Jezdec" id="about-obrazek" />
                      </div>
                      <div className="col-3 onas-text">
                        <p className={`html-unblock ${!element.text && 'loading-text'}`} id="about-predmluva" dangerouslySetInnerHTML={{ __html: element.text }}></p>
                      </div>
                    </React.Fragment>
                    ))}




                    </div>
                </div>
            </div>
        </div><br />

        </div>
    </motion.div>
    </>
  );
}

/*
[text(HTML), obrazek(URL, string)]

text OBRAZEK(flip)


<div>
  <p />
  <img />
</div>
*/

export default App;